import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';

import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-dm-dangkyedit',
  templateUrl: './dangkyedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./dangkyedit.component.scss'],
  providers: [ListService, Repository]
})


export class dangkyeditComponent implements OnInit {



  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, UserName: null, PassWord: null, RePassWord: null, TenCongTy: null
    , DiaChi: null, Email: null, GhiChu: null, FullName: null
  };    
  nhomdtid: string = null;
  hoatdong: string = null;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('slNhomCTMT', { static: false }) slNhomCTMT: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

  constructor(private _dataService: ListService, public repo: Repository) {


  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {

  }

  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {

    //if (nhomdoituongid.toLocaleLowerCase() === Lists_tinhchatnguonkp.id.toLocaleLowerCase())
    //  this.bnguonkinhphi = true;

    //if (nhomdoituongid.toLocaleLowerCase() === Lists_cmmt.id.toLocaleLowerCase())
    //  this.bnhomctmt = true;

    //if (nhomdoituongid.toLocaleUpperCase() == "5E79BF59-78D9-4C54-8EF7-0A242F5CBC24")
    //  this.hoatdong = "Ngừng theo dõi"
    //else
    this.hoatdong = "Hoạt động"

  

    this.nhomdtid = nhomdoituongid;
    setTimeout(() => {
      this.mafocus.nativeElement.focus();
    }, 500);
    //  this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/'+id+'/'+donviid)
    //  .subscribe(response => {            
    //      this.inputparents=response;
    //});
    //this.repo.getRequest("api/doituong/getall2/" + Lists_nhomctmt.id + '/null/' + donviid)
    //  .subscribe(response => {
    //    this.inputnhomctmts = response;
    //  });

    this.doituongSelect = {
      Id: null, UserName: null, PassWord: null, RePassWord: null, TenCongTy: null
      , DiaChi: null, Email: null, GhiChu: null, FullName: null
      , Created: null, Modified: null
    };


      this.doituongSelect.Created = new Date();
      this.doituongSelect.Modified = new Date();
      

  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.doituongSelect.UserName == null || this.doituongSelect.UserName == "") {
      swal('Lỗi!', 'Vui lòng số điện thoại (tài khoản đăng nhập) !.', 'error');
      return;
    }
    if (this.doituongSelect.PassWord == null || this.doituongSelect.PassWord == "") {
      swal('Lỗi!', 'Vui lòng nhập mật khẩu!.', 'error');
      return;
    }
    if (this.doituongSelect.RePassWord == null || this.doituongSelect.RePassWord == "") {
      swal('Lỗi!', 'Vui lòng nhập mật khẩu nhắc lại!.', 'error');
      return;
    }
    if (this.doituongSelect.PassWord !== this.doituongSelect.RePassWord) {
      swal('Lỗi!', 'Mật khẩu khác mật khẩu nhắc lại!.', 'error');
      return;
    }
    //if (this.doituongSelect.TenCongTy == null || this.doituongSelect.TenCongTy == "") {
    //  swal('Lỗi!', 'Vui lòng nhập tên đơn vị!.', 'error');
    //  return;
    //}
    if (this.doituongSelect.Email == null || this.doituongSelect.Email == "") {
      swal('Lỗi!', 'Vui lòng nhập email!.', 'error');
      return;
    }
    
    //if (this.doituongSelect.Ghi_Chu !== null && this.doituongSelect.Ghi_Chu.length > 300) {
    //  swal('Lỗi!', 'Ghi chú dài quá. Vui lòng nhập tối đa 300 ký tự!.', 'error');
    //  return;
    //}
    $('#loading').show();
    this.repo.postRequest("api/user/addorupdate_dangkysudung", this.doituongSelect)
      .subscribe(response => {
        console.log(response);
        $('#loading').hide();
        //if (response == 0 || (response != null && parseInt(response))) {
        if (response != null && response.match('-')) {
          //this.doituongSelect.Id = parseInt(response);
          swal('Thông báo!', "Đăng ký tài khoản thành công!", 'success');
          this.save.emit(this.doituongSelect);
        }
        else {
          swal('Lỗi!', response, 'error');
        }
      });
  }







}
